import React, { useContext, useEffect, useState } from 'react';
import { useQuery, useParameterizedQuery, useMutation } from 'react-fetching-library';
import toast from 'react-hot-toast';

import {
  getTfgFeedsAction,
  retryTfgFeedAction
} from '../../../services/request';

import { TfgFeedsColumns } from '../../../services/column-definitions';

const TfgContext = React.createContext();

export function useTfg() {
  return useContext(TfgContext);
}

export default function TfgProvider({ children }) {
  const { mutate } = useMutation(retryTfgFeedAction);
  const { loading: optionsLoading, payload: optionsPayload, error: optionsError } = useQuery(getTfgFeedsAction('OPTIONS'));

  const [search, setSearch] = useState(null);
  const [filtersParams, setFiltersParams] = useState(null);

  const {
    loading,
    payload,
    error,
    query
  } = useQuery(
    getTfgFeedsAction(
      'GET',
      null,
      search,
      filtersParams
    )
  );


  const { query: getFeedDetails } =
    useParameterizedQuery(getTfgFeedsAction);

  const [feeds, setFeeds] = useState([]);
  const [feed, setFeed] = useState({});
  const [columns] = useState(TfgFeedsColumns());
  const [choices, setChoices] = useState({});

  useEffect(() => {
    if (!loading && !error) {
      setFeeds(payload.results);
    }
  }, [loading, error, payload]);

  useEffect(() => {
    if (!optionsError && !optionsLoading) {
      setChoices(optionsPayload.actions.GET.choices);
    }
  }, [optionsLoading]);

  const getDetails = async id => {
    const {
      payload,
      loading,
      error
    } = await getFeedDetails('GET', id);

    if (!loading && !error) {
      return payload;
    }

    toast.error('Nie udało się pobrać szczegółów feeda.');

    return {};
  };

  const retryFeed = async id => {
    const { error } = await mutate(id);

    if (error) {
      toast.error('Nie udało się ponowić wysyłki feeda.');

      return;
    }

    toast.success('Feed został dodany ponownie do kolejki.');
    query();
  };

  return (
    <TfgContext.Provider
      value={{
        rowData: feed,
        setRowData: setFeed,

        rows: feeds,
        setRows: setFeeds,

        columns,

        getDetails,
        retryFeed,

        setSearch,
        setFiltersParams,

        loading,
        error,
        query,

        choices
      }}
    >
      {children}
    </TfgContext.Provider>
  );
}
